import React from 'react';
import { Icon } from 'venn-ui-kit';
import { cn } from '@/lib/utils';
import type { FundToProxy } from 'venn-components';
import type { FundToBulkProxy } from '../../types';
import type { SelectedProxy } from '../types';
import type { DetailedProxyMetadata } from 'venn-api';

const HoldingsProxySummary = ({
  investments,
  selectedProxy,
  proxyDataByFund,
}: {
  investments: (FundToProxy | FundToBulkProxy)[];
  selectedProxy: SelectedProxy;
  proxyDataByFund: Record<string, DetailedProxyMetadata | undefined> | undefined;
}) => {
  const anyInvestmentHasProxy = investments.some((investment) => proxyDataByFund?.[investment.id]?.proxyId);

  return (
    <div>
      <div className={cn('font-bold')}>Investment / Proxy Summary</div>
      <div className={cn('mt-[6px] p-[9px] bg-gray-100 grid grid-cols-[1fr_max-content] gap-y-[6px]')}>
        <div className={cn('text-venn-green font-bold mb-[6px]')}>Able to be proxied with {selectedProxy.name}</div>
        <div className={cn('font-bold')}>{anyInvestmentHasProxy && 'Has existing proxy?'}</div>

        {investments.map((investment) => (
          <React.Fragment key={investment.id}>
            <div className={cn('')}>
              <Icon type="check" className={cn('text-venn-green mr-[6px]')} />
              {investment.name}
            </div>

            <div className={cn('flex items-center')}>
              {proxyDataByFund?.[investment.id]?.proxyId ? <Icon type="check" /> : null}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default HoldingsProxySummary;
